import { render, staticRenderFns } from "./PreOrder.vue?vue&type=template&id=588fe1b8&scoped=true"
import script from "./PreOrder.vue?vue&type=script&lang=js"
export * from "./PreOrder.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./PreOrder.vue?vue&type=style&index=1&id=588fe1b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588fe1b8",
  null
  
)

export default component.exports